import { render } from "./RouteMap.vue?vue&type=template&id=2b275ee6"
import script from "./RouteMap.vue?vue&type=script&lang=ts"
export * from "./RouteMap.vue?vue&type=script&lang=ts"

import "./RouteMap.vue?vue&type=style&index=0&id=2b275ee6&lang=scss"
script.render = render

export default script